export const colorMapping = {
    "Money Market": "#69923a",
    "Short-Term Bond": "#0098db",
    "Total Bond": "#005293",
    "Total U.S. Stock": "#96151d",
    "TIFF Multi-Asset Pool": "#666666",
    "Total International Stock": "#f0aB00",
    "European Stock": "#e37222",
    "Pacific Stock": "#9a8419",
    "Emerging Markets Stock": "#a8b400",
    "Emerging Markets": "#a8b400",
    "Conservative Growth": "#003c69",
    "Moderate Growth": "#80379b",
    "Growth": "#983842",
    "Total Equity": "#770021",
    "Income": "#006778",
    "Total International Bond": "#e21c42",
    "Wellington": "#022737",
    "Balanced Index": "#999999",
    "ESG U.S. Stock": "#9F6AB8",
    "ESG International Stock": "#009aa6",
    "ESG Global Stock": "#415426",
    "Gift Preservation": "#006778",
    "Money Market Select": "#69923a",
    "Short-Term Bond Select": "#0098db",
    "Total Bond Select": "#005293",
    "Total U.S. Stock Select": "#96151d",
    "TIFF Multi-Asset Pool Select": "#666666",
    "Total International Stock Select": "#f0aB00",
    "European Stock Select": "#e37222",
    "Pacific Stock Select": "#9a8419",
    "Emerging Markets Select": "#a8b400",
    "Conservative Growth Select": "#003c69",
    "Moderate Growth Select": "#80379b",
    "Growth Select": "#983842",
    "Total Equity Select": "#770021",
    "Income Select": "#006778",
    "Total International Bond Select": "#e21c42",
    "Wellington Select": "#022737",
    "Balanced Index Select": "#999999",
    "ESG U.S. Stock Select": "#9F6AB8",
    "ESG International Stock Select": "#009aa6",
    "ESG Global Stock Select": "#415426",
    "Gift Preservation Select": "#006778",
    "Low Carbon Global Equity": "#ED637E",
    "S&P 500":"#09ac4b",
    "Extended Market":"#d6b88b",
    "Large-Cap Growth":"#ad8274",
    "Large-Cap Value":"#593d39",
    "Short-Term TIPS":"#b56728",
    "Ultra-Short-Term Bond":"#A4D361",
    "Real Estate":"#9EDDF8",
    "Global Positive Impact":"#DC571C",
    "Core Bond":"#D2A227",
    "International Core Stock":"#DFA87D",
    "Dividend Growth":"#BCB47C",
    "U.S. Growth":"#87A5BF",
    "Windsor II":"#BEB2DB",
    "Explorer":"#160E9D",
    "High-Yield Corporate":"#DF83D6",
    "Commodity Strategy":"#F3DE19"
}

export default colorMapping;